<template>
  <span tabindex="0" :class="wrapClasses" :style="wrapStyles" @click="toggle" @keydown.space="toggle">
    <input type="hidden" :name="name" :value="currentValue" />
    <span :class="innerClasses">
      <slot name="open" v-if="currentValue === trueValue"></slot>
      <slot name="close" v-if="currentValue === falseValue"></slot>
    </span>
  </span>
</template>
<script>
function broadcast(componentName, eventName, params) {
  this.$children.forEach((child) => {
    const name = child.$options.name

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params))
    } else {
      // todo 如果 params 是空数组，接收到的会是 undefined
      broadcast.apply(child, [componentName, eventName].concat([params]))
    }
  })
}

const prefixCls = 'ivu-switch'

export default {
  name: 'switchPlus',
  props: {
    value: {
      type: [String, Number, Boolean],
      default: false
    },
    trueValue: {
      type: [String, Number, Boolean],
      default: true
    },
    falseValue: {
      type: [String, Number, Boolean],
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size: {
      validator(value) {
        return ['large', 'small', 'default'].includes(value)
      },
      default() {
        return !this.$IVIEW || this.$IVIEW.size === '' ? 'default' : this.$IVIEW.size
      }
    },
    name: {
      type: String
    },
    loading: {
      type: Boolean,
      default: false
    },
    trueColor: {
      type: String
    },
    falseColor: {
      type: String
    },
    beforeChange: Function
  },
  data() {
    return {
      currentValue: this.value
    }
  },
  computed: {
    wrapClasses() {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-checked`]: this.currentValue === this.trueValue,
          [`${prefixCls}-disabled`]: this.itemDisabled,
          [`${prefixCls}-${this.size}`]: !!this.size,
          [`${prefixCls}-loading`]: this.loading
        }
      ]
    },
    wrapStyles() {
      const style = {}

      if (this.trueColor && this.currentValue === this.trueValue) {
        style['border-color'] = this.trueColor
        style['background-color'] = this.trueColor
      } else if (this.falseColor && this.currentValue === this.falseValue) {
        style['border-color'] = this.falseColor
        style['background-color'] = this.falseColor
      }

      return style
    },
    innerClasses() {
      return `${prefixCls}-inner`
    },
    itemDisabled() {
      const state = this.disabled
      // if (!state && this.FormInstance) state = this.FormInstance.disabled
      return state
    }
  },
  methods: {
    handleToggle() {
      const checked = this.currentValue === this.trueValue ? this.falseValue : this.trueValue

      this.currentValue = checked
      this.$emit('input', checked)
      this.$emit('on-change', checked)
      this.dispatch('FormItem', 'on-form-change', checked)
    },
    toggle(event) {
      event.preventDefault()
      if (this.itemDisabled || this.loading) {
        return false
      }

      if (!this.beforeChange) {
        return this.handleToggle()
      }

      const before = this.beforeChange()

      if (before && before.then) {
        before.then(() => {
          this.handleToggle()
        })
      } else {
        this.handleToggle()
      }
    },
    dispatch(componentName, eventName, params) {
      let parent = this.$parent || this.$root
      let name = parent.$options.name

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent

        if (parent) {
          name = parent.$options.name
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params))
      }
    },
    broadcast(componentName, eventName, params) {
      broadcast.call(this, componentName, eventName, params)
    }
  },
  watch: {
    value(val) {
      if (val !== this.trueValue && val !== this.falseValue) {
        // eslint-disable-next-line
        throw 'Value should be trueValue or falseValue.'
      }
      this.currentValue = val
    }
  }
}
</script>
